const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrozenCards(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#F8EBEA",
    style: {
      fill: "#F8EBEA",
      fill: "color(display-p3 0.9725 0.9216 0.9176)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9 10H17.1C16.42 10 15.46 10.4 14.98 10.88L10.88 14.98C10.4 15.46 10 16.42 10 17.1V22.9C10 23.58 10.4 24.54 10.88 25.02L14.98 29.12C15.46 29.6 16.42 30 17.1 30H22.9C23.58 30 24.54 29.6 25.02 29.12L29.12 25.02C29.6 24.54 30 23.58 30 22.9V17.1C30 16.42 29.6 15.46 29.12 14.98L25.02 10.88C24.54 10.4 23.58 10 22.9 10Z",
    stroke: "#B42318",
    style: {
      stroke: "#B42318",
      stroke: "color(display-p3 0.7059 0.1373 0.0941)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9399 27.08L27.0799 12.94",
    stroke: "#B42318",
    style: {
      stroke: "#B42318",
      stroke: "color(display-p3 0.7059 0.1373 0.0941)",
      strokeOpacity: 1
    },
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrozenCards);
export default __webpack_public_path__ + "static/media/frozenCards.f820202a1f4096ceb1f481be4fca859f.svg";
export { ForwardRef as ReactComponent };